import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
	&.visible {
		margin: 0;
	}

	.modal-wrapper {
		position: absolute;
		margin: 0 1em 0 1em;
		left: 0;
		top: 0;
		width: calc(100% + 4.5em);
		transform: translateX(-3.2em);
		height: max-content;
		z-index: 999;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: ${vars.colorBackgroundContrast};

		.modal {
			padding: 4em;
			max-width: 60em;

			.modal-title {
				font-size: 1.4em;
				font-weight: 600;
				text-align: center;
				margin-bottom: 0.3em;
			}
			.modal-subtitle {
				font-size: 1em;
				font-weight: 400;
				text-align: center;
				margin-bottom: 2em;
			}
			.register-button {
				.button {
					background-color: #10f5b0;
				}
			}
		}
	}

	@media all and (max-width: ${vars.tabletL}) {
		&.visible {
			height: 40em;
		}

		.modal-wrapper {
			padding: 2em;
			min-height: 100%;

			.modal {
				padding: 1em;

				.layout-forms-checkbox {
					.label-wrapper {
						font-size: 1.4em;
					}
					.label-expanded-button {
						font-size: 1.1em;
					}
				}

				.modal-title {
					font-size: 1.7em;
					text-align: left;
				}
				.modal-subtitle {
					font-size: 1.2em;
					text-align: left;
				}
				.rows {
					flex-flow: column wrap;
				}
			}
		}
	}
`;
